import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { useQuery } from "react-query"
import { listLabs } from "~/actions/labs"
import AdminActionBar from "~/components/Common/AdminActionBar"
import LabStatusFilters from "~/components/Labs/LabStatusFilters"
import LabsCardList from "~/components/Labs/LabsCardList"
import AppContext from "~/contexts/App"
import LabsContext from "~/contexts/Labs"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../../../components/Common/Box"
import useStyles from "./styles"

const List = ({ routes = [], ...rest }) => {
  const classes = useStyles()

  const { openDialog, setPageTitle, setPageSubTitle } = useContext(AppContext)
  const { createLabMutation } = useContext(LabsContext)
  //set serach value
  const [searchValue, setSearchValue] = useState("")
  //set sort data
  const [sort, setSort] = useState({
    name: "",
    type: "",
    direction: "",
    icon: "",
  })

  const filterOptions = [
    { id: 1, name: "Name" },
    { id: 2, name: "Type" },
    { id: 3, name: "Last Updated" },
  ]

  const { data: labs, isLoading: labsLoading } = useQuery("labs", listLabs)

  //set lesson title and subtitle
  useEffect(() => {
    setPageTitle("Labs")
    setPageSubTitle(labs?.length)
  }, [labs])

  //reusable dialog to create lessons, courses, clientes and instructor
  //pass a title, subtitle, type (for example course) a create mutation func and refecth data
  const openCreateDialog = () => {
    let data = {
      title: "New Lab",
      subtitle: "Create a new Lab",
      type: "lab",
      create: createLabMutation,
    }
    openDialog("createCourseLessonDialog", data)
  }
  //set lessons status
  const [statusState, setStatusState] = useState("locked")
  const watchHash = () => {
    const newHash = window.location.hash.replace("#", "")
    if (newHash) {
      setStatusState(newHash)
    }
  }
  useEffect(() => {
    window.removeEventListener("hashchange", watchHash)
    window.addEventListener("hashchange", watchHash, false)
  })
  //set the length of each type of lesson
  const [statusNumber, setStatusNumber] = useState({
    locked: null,
    unlocked: null,
  })

  if (sort?.direction === "") {
    sort.name = ""
    sort.type = ""
  }

  return (
    <Page>
      <AdminActionBar
        buttonName="New Lab"
        buttonFunc={openCreateDialog}
        sortOptions={filterOptions}
        sortState={sort}
        setSortState={setSort}
        setFilterState={setSearchValue}
        placeholder="Search labs"
      />
      {labsLoading ? (
        <LinearProgress color="primary" />
      ) : (
        <Box display="flex" height="100%" className={classes.container}>
          <Box className={classes.leftContainer}>
            <LabStatusFilters
              setStatusState={setStatusState}
              statusState={statusState}
              statusNumber={statusNumber}
            />
          </Box>

          <Box className={classes.rightContainer}>
            <LabsCardList
              labs={labs}
              searchValue={searchValue}
              sort={sort}
              openCreateDialog={openCreateDialog}
              statusState={statusState}
              setStatusNumber={setStatusNumber}
            />
          </Box>
        </Box>
      )}
      <Router routes={routes} {...rest} />
    </Page>
  )
}

List.propTypes = {
  routes: PropTypes.array,
}

export default List
